import 'slick-carousel/slick/slick.min';
import inView from 'in-view';

export default class FrontPage {
    constructor()
    {
        FrontPage.hero();
        FrontPage.section_social();
        FrontPage.link_agenda();
        FrontPage.section_partner();
    }

    static hero()
    {
        var $hero_slider = $('#hero-slider');
        var self = this;

        if ( $hero_slider.length > 0 ) {

            $hero_slider.on('init', function(e, slick) {
                FrontPage.slider_video( slick, $hero_slider );

                setTimeout( function() {
                    $hero_slider.addClass('is-ready');
                }, 1000);
            });

            $hero_slider.slick({
                slide: '.slide-item',
                arrows: true,
                dots: false,
                appendArrows: $hero_slider.siblings('.slider__nav'),
                pauseOnHover: true,
                infinite: true,
                fade: true,
                speed: 1000,
                slidesToShow: 1,
                autoplay: true,
                autoplaySpeed: 5000,
            });

            $hero_slider.on('afterChange', function(e, slick, currentSlide) {
                FrontPage.slider_video( slick, $hero_slider );
                $hero_slider.slick('slickPlay');
            });

            FrontPage.video_mute_action();
        }
    }

    static slider_video(slick, $hero_slider) {
        
        if ( window.matchMedia("(max-width: 740px)").matches ) {
            
            return false;
        }
        else {
            
            $hero_slider.find('video').attr('preload', 'auto').prop('autoplay', true);
        }
        
        setTimeout( function() {
            var $current_slide = $(slick.$slides[slick.currentSlide]);
            var $video         = $current_slide.find('video');
            var $videos        = $hero_slider.find('video');
            
            $videos.each( function() {
                $(this).get(0).pause();
                if ( ! $(this).hasClass('is-muted') ) {
                    $(this).get(0).muted = false;
                }
            });
            
            if ( $video.length > 0 ) {
                $video.get(0).play();
                $hero_slider.slick('slickPause');
                $video.on('ended', function() {
                    setTimeout( function() {
                        $video.get(0).currentTime = 0;
                    }, 0);
                    $hero_slider.slick('slickNext');
                    $hero_slider.slick('slickPlay');
                    $video.off('ended');
                });
            }
        }, 0);
    }

    static video_mute_action()
    {
        $('.js-video-mute').on('click', function(e) {
            e.preventDefault();

            var $that  = $(this);
            var $video = $that.siblings('video');

            if ( $video.get(0).muted == false ) {
                $video.get(0).muted = true;
                $video.addClass('is-muted')
                $that.find('i').toggleClass( 'fa-volume-up fa-volume-off' );
            } else {
                $video.get(0).muted = false;
                $video.removeClass('is-muted')
                $that.find('i').toggleClass( 'fa-volume-up fa-volume-off' );
            }
        });
    }

    static section_social()
    {
        const $element = $('[data-id="ajax-instagram--homepage"]');

        if ( $element.length ) {

            // if ( window.matchMedia("(min-width: 651px)").matches ) {
            
                inView('[data-id="ajax-instagram--homepage"]').once('enter', function() {

                    $.ajax({
                        url: Theme.rest_url + 'theme/v1/instagram',
                        method: 'GET',
                        beforeSend: function ( xhr ) {
                            xhr.setRequestHeader( 'X-WP-Nonce', Theme.rest_nonce );
                        },
                        success: function ( response ) {
                            if ( response ) {
                                $element.html( response );
                            } else {
                                setTimeout(FrontPage.section_social, 1500);
                            }
                        }
                    });
                });
            // }
        }
    }

    static link_agenda()
    {
        // Link to agenda
        $('#link-agenda-home .list-event__cta__link').on('click', function(e) {
            e.preventDefault();

            var value = $(this).data('value');

            $('#period_value').val( value );
            $('#form-agenda-home').submit();
        });
    }

    static section_partner()
    {
        var $slider_partner = $('#slider-partner');

        if ( $slider_partner.length > 0 ) {

            $slider_partner.slick({
                slide: '.slide-item',
                lazyLoad: 'ondemand',
                arrows: true,
                dots: false,
                // appendArrows: $slider_partner.siblings('.slider__nav'),
                // pauseOnHover: true,
                infinite: true,
                // fade: true,
                // speed: 1000,
                slidesToShow: 4,
                // autoplay: true,
                // autoplaySpeed: 5000,
                responsive: [
                    {
                        breakpoint: 1001,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 651,
                        settings: {
                            slidesToShow: 2,
                        }
                    }
                ]
            });
        }
    }
}